import { BillingAccountDetails } from '../interfaces';

export function getBankAccountString(bankAccount: BillingAccountDetails) {
  return `${bankAccount.bank} (${bankAccount?.accountName ? `${bankAccount?.accountName} | ` : ''}${
    bankAccount?.account
  })`;
}
